import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Prep",
    body:
      "We move furniture, mask edges, patch drywall, sand, and prime like the finish depends on it — because it does. No shortcuts. No cover-ups.",
  },
  {
    n: "02",
    title: "Paint",
    body:
      "Two coats, crisp lines, premium paint. Interior or exterior. We treat every wall like it's the only one you'll ever see.",
  },
  {
    n: "03",
    title: "Perfect",
    body:
      "Walk-through with you before we leave. If it's not right, it's not done. Great quality. Great experience. Every time.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="process"
      data-testid="manifesto-section"
      className="relative py-32 md:py-48 border-t border-brand-border"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-4 lg:sticky lg:top-32 self-start">
          <div className="text-[11px] tracking-[0.3em] uppercase text-brand-muted mb-6 flex items-center gap-3">
            <span className="h-px w-8 bg-brand-blue" />
            The Process
          </div>
          <h2 className="font-display uppercase text-6xl md:text-7xl leading-[0.9] tracking-tight">
            Three <br />
            <span className="text-brand-blue">Chapters.</span>
            <br />
            Zero <br />
            Shortcuts.
          </h2>
          <p className="mt-6 text-brand-muted max-w-sm font-sans">
            Every project follows the same disciplined process — from prep to
            final walk-through.
          </p>
        </div>

        <div className="lg:col-span-8 flex flex-col gap-24">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.9, ease: [0.6, 0.05, 0.15, 1] }}
              className="border-t border-brand-border pt-10"
              data-testid={`chapter-${c.n}`}
            >
              <div className="flex items-baseline gap-8 mb-6">
                <span className="font-display text-brand-blue text-[9vw] md:text-[7vw] leading-none tracking-tight">
                  {c.n}
                </span>
                <span className="font-display uppercase text-4xl md:text-6xl leading-none">
                  {c.title}
                </span>
              </div>
              <p className="text-brand-muted text-base md:text-lg max-w-xl leading-relaxed">
                {c.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
